import { render, staticRenderFns } from "./ProposalCp.vue?vue&type=template&id=2eb98d36&scoped=true&"
import script from "./ProposalCp.vue?vue&type=script&lang=js&"
export * from "./ProposalCp.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCp.vue?vue&type=style&index=0&id=2eb98d36&prod&scoped=true&lang=scss&"
import style1 from "./ProposalCp.vue?vue&type=style&index=1&id=2eb98d36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb98d36",
  null
  
)

export default component.exports